import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../../components/navbar/Navbar";

export default function HomepageContainer() {
  document.title = "अहिल्यानगर महानगरपालिका,अहिल्यानगर";
  return (
    <>
      <Navbar />
      <div className="min-vh-100">
        <Outlet />
      </div>
    </>
  );
}
